 <!-- 入库表单 -->
 <template>
    <div>
        <el-dialog v-dialogDrag title="入库" width="65%"  :visible.sync="dialogShowIn" :close-on-click-modal="false"
            :before-close="handleClose">
            <el-form :rules="rules" ref="storeFormIn" :model="storeFormIn" label-width="80px" size="mini"> 
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="供应商">
                            <el-input v-model="storeFormIn.supplier"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="入库类型">
                            <el-select style="width: 100%;" v-model="storeFormIn.taskType" placeholder="请选择">
                                <el-option v-for="item in inStorageType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                     </el-col>
                </el-row>
                <el-row>
                    <el-col :span="21">
                        <el-form-item label="备注">
                            <el-input v-model="storeFormIn.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" style="display: flex;justify-content: flex-end;">
                        <el-button type="primary" size="mini" @click="saveBillHead()">保存</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div class="label_box" >
                <div class="label">
                    上传附件
                </div>
                <div>
                    <el-upload class="upload-demo" :action="fileUploadURL" :file-list="fileList" :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" multiple >
                    <el-button slot="trigger" size="small" type="primary" plain style="margin-right: 10px;">选择文件</el-button>
                    <el-button size="small" type="success" plain @click="uploadFiles()">点击上传</el-button>
                    </el-upload>
                    <div>
                        <span v-for="item in newFileList" :key="item.id">
                            <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.fileName }}</el-link>
                        </span>
                    </div>
                </div>
            </div>
            <div style="margin-left: 20px; ">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom-start">
                    <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addstore()"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom-start">
                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delstore()"></el-button>
                </el-tooltip>
            </div>
            <!-- 规格表格 -->
             <el-table :data="storeTable" style="width: 100%" @selection-change="handleSelectionChange" size="mini"
             :header-cell-style="{'text-align':'center'}">
                <el-table-column type="selection" width="50"> </el-table-column>
                <el-table-column prop="goodName" label="品名">
                    <template slot-scope="scope">
                        <el-input size="mini" clearable v-model="scope.row.goodName"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位"> 
                    <template slot-scope="scope">
                        <el-input size="mini" clearable v-model="scope.row.unit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="数量"> 
                    <template slot-scope="scope">
                        <el-input size="mini" clearable v-model="scope.row.num"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="unitPrice" label="单价"> 
                    <template slot-scope="scope">
                        <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" size="mini" clearable v-model="scope.row.unitPrice" autocomplete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="total" label="总价"> 
                    <template slot-scope="scope">
                        <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"  size="mini" clearable v-model="scope.row.total" autocomplete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"> 
                    <template slot-scope="scope">
                        <el-input size="mini" clearable v-model="scope.row.remark"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogShowIn = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog v-dialogDrag title="出库" width="60%" :visible.sync="dialogShowOut" :close-on-click-modal="false"
            :before-close="handleClose">
            <el-form ref="storeFormOut" :model="storeFormOut" label-width="80px" size="mini"> 
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="出库类型">
                            <el-select style="width: 100%;" v-model="storeFormOut.supplier" placeholder="请选择">
                                <el-option v-for="item in outStorageType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="8">
                        <el-form-item label="领用人">
                            <el-input v-model="storeFormOut.taskType"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="8">
                        <el-form-item label="领用部门">
                            <el-input v-model="storeFormOut.taskType"></el-input>
                        </el-form-item>
                     </el-col>
                </el-row>
                <el-row>
                    <el-col :span="21">
                        <el-form-item label="备注">
                            <el-input v-model="storeFormOut.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" style="display: flex;justify-content: flex-end;">
                        <el-button type="primary" size="mini" @click="saveBillHead()">保存</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div class="label_box" >
                <div class="label">
                    上传附件
                </div>
                <div>
                    <el-upload class="upload-demo" :action="fileUploadURL" :file-list="fileList" :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" multiple >
                    <el-button slot="trigger" size="small" type="primary" plain style="margin-right: 10px;">选择文件</el-button>
                    <el-button size="small" type="success" plain @click="uploadFiles()">点击上传</el-button>
                    </el-upload>
                    <div>
                        <span v-for="item in newFileList" :key="item.id">
                            <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.fileName }}</el-link>
                        </span>
                    </div>
                </div>
            </div>
            <div style="margin-left: 20px; ">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom-start">
                    <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addstore()"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom-start">
                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delstore()"></el-button>
                </el-tooltip>
            </div>
            <!-- 规格表格 -->
             <el-table :data="storeTable" style="width: 100%" @selection-change="handleSelectionChange" size="mini"
             :header-cell-style="{'text-align':'center'}">
                <el-table-column type="selection" width="50"> </el-table-column>
                <el-table-column prop="goodName" label="品名">
                    <template slot-scope="scope">
                        <el-input size="mini" clearable v-model="scope.row.goodName"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="unit" label="现有库存"> 
                    <template slot-scope="scope">
                        <el-input :disabled="true" size="mini" clearable v-model="scope.row.unit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="出库数量"> 
                    <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.num" @change="handleChange" :min="1" :max="10" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column prop="unitPrice" label="单价"> 
                    <template slot-scope="scope">
                        <el-input :disabled="true" size="mini" v-model="scope.row.unitPrice" ></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="total" label="总价"> 
                    <template slot-scope="scope">
                        <el-input :disabled="true" size="mini" v-model="scope.row.total"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"> 
                    <template slot-scope="scope">
                        <el-input size="mini" clearable v-model="scope.row.remark"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogShowOut = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import basicData from '@/config/basicData.js'
    export default {
        name: '',
        props: {
            dialogShowIn: {
                type: Boolean,
                default: false
            },
            dialogShowOut: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                inStorageType:basicData.inStorageType,
                outStorageType:basicData.outStorageType,
                storeFormIn:{
                    supplier:'',// 供应商
                    stockType:'入库',
                    remark:'', // 备注
                    taskType:'', // 类型
                },
                storeFormOut:{
                    // 领用人、领用部门
                    stockType:'出库',
                    remark:'', // 备注
                    taskType:'', // 类型
                },
                storeTable:[
                    {
                        goodName:'', // 名称
                        unit:'', // 单位
                        num:'', // 数量
                        unitPrice:'', // 单价
                        total:'', // 总价
                        remark:'', // 备注
                    }
                ],
                selectStore:[], // 选中的序号列表
                fileList:[], // 上传附件列表
                newFileList:[], // 上传成功列表
                fileUploadURL:process.env.VUE_APP_BASE_API + 'admin/goods/uploadFiles', // 文件上传URL
            }
        },
        methods: {
            // 关闭窗口
            handleClose() {
                this.$emit('closeDialog', false);
            },
            // 选中的费用信息序号列表--子任务
            handleSelectionChange(val){
                const selectedIndexes = val.map(row => {
                    return this.storeTable.indexOf(row); // 返回索引（0开始）
                    });
                this.selectStore = selectedIndexes
            },
            addstore(){
                const item = {
                    goodName:'', // 名称
                    unit:'', // 单位
                    num:'', // 数量
                    unitPrice:'', // 单价
                    total:'', // 总价
                    remark:'', // 备注
                }
                this.storeTable.push(item);
            },
            delstore(){
                if(this.selectStore.length){
                    this.selectStore.sort((a, b) => b - a); // 降序排列数组
                    this.selectStore.map(item => {
                        this.storeTable.splice(item, 1);
                    })
                }else{
                    this.$message({
                        message: '请先选中物资',
                        type: 'warning'
                    });
                }
            },
            // 文件上传时勾子-
            handleChange(file, fileList){
                this.fileList = fileList
            },
            // 移除文件勾子
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
        }
    }
</script>
<style lang="css" scoped>
.label_box{
    display: flex;
    margin-bottom: 10px;
}
.label{
    width: 80px;
    line-height:28px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box
}
.list-margin{
    margin-right: 10px;
}
</style>